import React from "react";
import { Button } from "react-bootstrap";
import "../utils/detail.css";
import defaultAvatar from "../../../../assets/images/default-avatar.png";
import { useNavigate } from "react-router-dom";
import {
  EnvironmentOutlined,
  MailOutlined,
  PhoneOutlined,
} from "@ant-design/icons";

const DeveloperInfoMarchand = ({ developer }) => {
  const navigate = useNavigate();

  const handleDetail = (developer) => {
    if (!developer || !developer.merchantId) {
      console.warn("Developer invalide :", developer);
      return;
    }
    navigate(`/marchands/${developer.merchantId}`);
  };
  const InfoRow = ({ icon, label, value }) => (
    <div
      style={{
        display: "flex",
        alignItems: "flex-start",
        gap: "12px",
        width: "100%",
        marginTop: "20px",
      }}
    >
      {/* Icône */}
      <div style={{ minWidth: "40px" }}>
        <div
          style={{
            backgroundColor: "#F0F0F0",
            width: "30px",
            height: "30px",
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {icon}
        </div>
      </div>
      <div style={{ flex: 1 }}>
        <div className="tel" style={{ textAlign: "left" }}>
          {label}
        </div>

        <div
          className="tels"
          style={{
            wordBreak: "break-word",
            overflowWrap: "break-word",
            textAlign: "left",
          }}
        >
          {value || "-"}
        </div>
      </div>
    </div>
  );
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        padding: "20px",
      }}
    >
      <div
        style={{
          width: "336px",
          backgroundColor: "#FFFFFF",
          padding: "20px",
          border: "1px solid #0000001A",
          borderRadius: "10px",
        }}
      >
        <div style={{display: "flex",justifyContent: "center",alignItems: "center" }}>
          <img
            src={defaultAvatar}
            alt="logo"
            style={{
              width: 46,
              height: 46,
              borderRadius: "50%",
              objectFit: "cover",
            }}
            
          />
        </div>
        <div style={{ textAlign: "center", marginTop: "10px" }}>
          <span className="names">{developer?.merchantName}</span>
        </div>
        <div style={{ textAlign: "center" }}>
          <span className="titles">Marchand</span>
        </div>
        <InfoRow
          icon={<PhoneOutlined />}
          label="N° Téléphone"
          value={developer?.merchantPhoneNumber}
        />
        <hr className="hrSep" />
        <InfoRow
          icon={<EnvironmentOutlined />}
          label="Adresse"
          value={developer?.adress}
        />
        <hr className="hrSep" />
        <InfoRow
          icon={<MailOutlined />}
          label="Email"
          value={developer?.merchantEmail}
        />
        <Button
          onClick={() => handleDetail(developer)}
          style={{ marginTop: "30px", width: "100%" }}
          className="deconnect-button-admin menue-admin"
        >
          Consulter le compte
        </Button>
      </div>
    </div>
  );
};

export default DeveloperInfoMarchand;